export type DateInMs = number;

export const ONE_WEEK = 60 * 60 * 24 * 7;

export const ONE_HOUR = 60 * 60;

export const TEN_MINUTES = 10 * 60;

export enum BREADCRUMB_FILTER_BY_ENUM {
  FREE_TEXT = "0",
  AUTOCOMPLETE = "1",
}

export const ALARM_TYPES_FE = [
  {
    id: "ON_OFF",
    alias: "ON and OFF",
  },
  {
    id: "ACK",
    alias: "ACK",
  },
  {
    id: "ACK_RESET",
    alias: "ACK and RESET",
  },
];

export const ALARM_STRUCT = {
  ON_OFF: {
    states: [
      {
        state: "ALARM ON",
        description: "",
        corvinaStates: ["ACTIVE"],
        actions: [],
      },
      { state: "ALARM OFF", description: "", final: true },
    ],
    events: [
      { label: "CONDITION ON", type: "TRIGGER", policy: {} },
      { label: "CONDITION OFF", type: "TRIGGER", policy: {} },
    ],
    transitions: [
      { toStates: ["ALARM ON"], events: ["CONDITION ON"] },
      {
        fromState: "ALARM ON",
        toStates: ["ALARM OFF"],
        events: ["CONDITION OFF"],
      },
    ],
  },
  ACK: {
    states: [
      {
        state: "ALARM ON",
        description: "",
        corvinaStates: ["ACTIVE", "REQUIRES_ACK"],
        actions: [],
      },
      {
        state: "ALARM ON ACKED",
        description: "",
        corvinaStates: ["ACTIVE", "ACKED"],
      },
      { state: "ALARM OFF", description: "", corvinaStates: ["REQUIRES_ACK"] },
      {
        state: "ALARM OFF ACKED",
        description: "",
        corvinaStates: ["ACKED"],
        final: true,
      },
    ],
    events: [
      { label: "CONDITION ON", type: "TRIGGER", policy: {} },
      { label: "ACK RECEIVED", type: "ACK" },
      { label: "CONDITION OFF", type: "TRIGGER", policy: {} },
    ],
    transitions: [
      { toStates: ["ALARM ON"], events: ["CONDITION ON"] },
      {
        fromState: "ALARM ON",
        toStates: ["ALARM OFF"],
        events: ["CONDITION OFF"],
      },
      {
        fromState: "ALARM OFF",
        toStates: ["ALARM OFF ACKED"],
        events: ["ACK RECEIVED"],
      },
      {
        fromState: "ALARM ON",
        toStates: ["ALARM ON ACKED"],
        events: ["ACK RECEIVED"],
      },
      {
        fromState: "ALARM ON ACKED",
        toStates: ["ALARM OFF ACKED"],
        events: ["CONDITION OFF"],
      },
    ],
  },
  ACK_RESET: {
    states: [
      {
        state: "ALARM ON",
        description: "",
        corvinaStates: ["ACTIVE", "REQUIRES_ACK"],
        actions: [],
      },
      {
        state: "ALARM ON ACKED",
        description: "",
        corvinaStates: ["ACTIVE", "ACKED"],
      },
      { state: "ALARM OFF", description: "", corvinaStates: ["REQUIRES_ACK"] },
      {
        state: "ALARM OFF ACKED",
        description: "",
        corvinaStates: ["ACKED", "REQUIRES_RESET"],
      },
      { state: "ALARM RESET", description: "", final: true },
    ],
    events: [
      { label: "CONDITION ON", type: "TRIGGER", policy: {} },
      { label: "ACK RECEIVED", type: "ACK" },
      { label: "CONDITION OFF", type: "TRIGGER", policy: {} },
      { label: "RESET RECEIVED", type: "RESET" },
    ],
    transitions: [
      { toStates: ["ALARM ON"], events: ["CONDITION ON"] },
      {
        fromState: "ALARM ON",
        toStates: ["ALARM OFF"],
        events: ["CONDITION OFF"],
      },
      {
        fromState: "ALARM OFF",
        toStates: ["ALARM OFF ACKED"],
        events: ["ACK RECEIVED"],
      },
      {
        fromState: "ALARM ON",
        toStates: ["ALARM ON ACKED"],
        events: ["ACK RECEIVED"],
      },
      {
        fromState: "ALARM ON ACKED",
        toStates: ["ALARM OFF ACKED"],
        events: ["CONDITION OFF"],
      },
      {
        fromState: "ALARM OFF ACKED",
        toStates: ["ALARM RESET"],
        events: ["RESET RECEIVED"],
      },
    ],
  },
};

export const ALARM_TYPES_DB = ALARM_TYPES_FE.concat([
  { id: "CUSTOM", alias: "CUSTOM" },
]);

export const ALARM_SEVERITY = [
  { value: 0, title: "0 - Not important" },
  { value: 1, title: "1 - Low" },
  { value: 2, title: "2 - Below normal" },
  { value: 3, title: "3 - Normal" },
  { value: 4, title: "4 - Above normal" },
  { value: 5, title: "5 - High" },
  { value: 6, title: "6 - Critical" },
];

export enum AlarmOrderBy {
  name = "name",
  updatedAt = "updatedAt",
}

export enum CountersOrderBy {
  timestamp = "timestamp",
}

export enum SortDTO {
  ASC = "asc",
  DESC = "desc",
}

export enum DeviceGroupType {
  SELF_DEVICE = 'SELF_DEVICE',
  ALL_DEVICES = 'ALL_DEVICES',
  STANDARD = 'STANDARD',
  DEVICE_TEXT_FIELD = 'DEVICE_TEXT_FIELD',
  DEVICE_GROUP_TEXT_FIELD = 'DEVICE_GROUP_TEXT_FIELD',
  NO_DEVICES_PLACEHOLDER = 'NO_DEVICES_PLACEHOLDER'
}

const serviceHost = import.meta.env.VITE_SERVICE_URL || window.location.origin;

export type Constants = {
  serviceUrl: string;
};

export const constants: Constants = {
  serviceUrl: `${serviceHost}/v1`,
};

export const completionItems = ["alarmInstanceId", "deviceId", "modelPath", "value", "timestamp", "timestampISO", "timestampLocal", "deviceLabel", "comment", "organizationId", "instanceId"];
